import TaskObjectCard from './TaskObjectCard'

export * from './TaskObjectCard.types'

export default TaskObjectCard
